import { render, staticRenderFns } from "./zhuxiao.vue?vue&type=template&id=4eeec51e&scoped=true&"
import script from "./zhuxiao.vue?vue&type=script&lang=js&"
export * from "./zhuxiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeec51e",
  null
  
)

export default component.exports